var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonospace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.021 2.906c.186 1.219.372 1.5.372 2.719C1.393 6.375 0 7.031 0 7.031v.938s1.393.656 1.393 1.406c0 1.219-.186 1.5-.372 2.719C.743 14.063 1.764 15 2.693 15h1.95v-1.875s-1.672.188-1.672-.938c0-.843.186-.843.372-2.718.093-.844-.464-1.5-1.022-1.969.558-.469 1.115-1.031 1.022-1.875C3.064 3.75 2.97 3.75 2.97 2.906c0-1.125 1.672-1.031 1.672-1.031V0h-1.95C1.67 0 .743.938 1.02 2.906zM11.979 2.906c-.186 1.219-.372 1.5-.372 2.719 0 .75 1.393 1.406 1.393 1.406v.938s-1.393.656-1.393 1.406c0 1.219.186 1.5.372 2.719.278 1.969-.743 2.906-1.672 2.906h-1.95v-1.875s1.672.188 1.672-.938c0-.843-.186-.843-.372-2.718-.093-.844.464-1.5 1.022-1.969-.558-.469-1.115-1.031-1.022-1.875.186-1.875.372-1.875.372-2.719 0-1.125-1.672-1.031-1.672-1.031V0h1.95c1.022 0 1.95.938 1.672 2.906z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonospace);
export default __webpack_public_path__ + "static/media/monospace.f0b4d35108b6cab4041f4b5ef6a4b2f1.svg";
export { ForwardRef as ReactComponent };